// No React import: this component renders only what it is handed - children or
// a fallback - so there is no JSX here and nothing for React to be in scope for.
import { Component } from 'react';
import PropTypes from 'prop-types';

// Contains a crash instead of letting it take the whole app down.
//
// React 16 unmounts the entire tree when an error escapes render or a
// commit-phase lifecycle and no boundary catches it, which shows up as a
// completely white page. That is exactly what a blocked pop-up used to do
// here: react-new-window@0.1.3 assigns
//
//     this.container = this.window.document.createElement("div")
//
// before it checks whether window.open returned null, so a blocked pop-up
// throws a TypeError inside componentDidMount and the library's own onBlock
// path is never reached. The main TeamX window went white, a reload brought it
// back, and MemberList's timer re-mounted the pop-up a few seconds later and
// whited it out again.
//
// Wrapping the pop-up in one of these keeps the failure local: the subtree is
// dropped, onError lets the parent explain itself to the user, and the rest of
// the app carries on. Deliberately not a node_modules patch - a clean
// npm install would silently undo that, and this covers every way a detached
// window can fail rather than one library's ordering bug.
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { failed: false };
    }

    componentDidCatch(error, info) {
        this.setState({ failed: true });
        if (typeof this.props.onError === 'function') {
            this.props.onError(error, info);
        }
    }

    render() {
        if (this.state.failed) {
            // Nothing by default. The parent decides what to say - the message
            // for a blocked pop-up belongs next to the thing that opened it,
            // not in here.
            return this.props.fallback !== undefined ? this.props.fallback : null;
        }
        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    onError: PropTypes.func,
    fallback: PropTypes.node,
    children: PropTypes.node,
};

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js